@if (headerText) {
  <div class="header">
    <h2>{{ headerText }}</h2>
  </div>
}

<div class="actions-selector" #batchModeSelector>
@if (!selectPlannedActivitiesMode) {
    <p-select-button [options]="actionsSelectorOptions" [(ngModel)]="selectedActionsSelector" (onChange)="actionsSelectorChanged()"></p-select-button>
}
</div>

<div class="actions" #actions>
  @if (!onlySelectOne) {
    <div class="selection-tools action-box">
      <label>Select {{ selectedActionsSelector === 'plan' ? 'available' : 'planned' }} activities</label>
      <div class="action-controls flex">
        <div class="row">
          <p-button (click)="selectAll(); $event.stopPropagation(); " size="small">
            All
          </p-button>
          <p-button (click)="selectNone(); $event.stopPropagation();" size="small">
            None
          </p-button>
          <p-button (click)="invertSelection(); $event.stopPropagation();" size="small">
            Invert
          </p-button>
          <div class="item">
            <p-button (click)="selectByAutomatable(); $event.stopPropagation();" size="small">
              With automation
            </p-button>
          </div>
        </div>
        <div class="row">
          <div>By</div>
          <div class="item">
            <p-button (click)="byLabelMenu.toggle($event)" size="small">Label</p-button>
            <p-popover #byLabelMenu appendTo="body" [dismissable]="true">
              <p-list-box  [filter]="true" optionLabel="label" optionValue="value" [options]="specLabelsMenu" (onChange)="applyLabelsSelection($event.value); byLabelMenu.hide()" [scrollHeight]="'300px'">
                <ng-template let-label pTemplate="item">
                  <div class="label-item flex">
                    <div class="color-box" [ngStyle]="{'background-color': label.color}"></div>
                    <div class="label-name">{{ label.label }}</div>
                  </div>
                </ng-template>
              </p-list-box>
            </p-popover>
          </div>
          <div class="item">
            <p-button (click)="byExecutionStatusMenu.toggle($event)" size="small">Execution Status</p-button>
            <p-menu #byExecutionStatusMenu [model]="executionStatusMenu" [popup]="true" appendTo="body" ></p-menu>
          </div>
          <div class="item">
            <p-button (click)="byEvaluationStatusMenu.toggle($event)" size="small">Evaluation Status</p-button>
            <p-menu #byEvaluationStatusMenu [model]="evaluationStatusMenu" [popup]="true" appendTo="body" ></p-menu>
          </div>
        </div>
      </div>
      <div class="info-text">
        {{ selectedActivitiesCount }} activities selected
      </div>
    </div>
    @if (selectedActionsSelector === 'plan') {
      <div class="planning-status action-box">
        <div class="action-controls">
          <div class="row">
            <p-button [disabled]="!selectedActivitiesCount" (click)="addSelectedActivitiesToPlanningMatrix()" size="large" data-testing-id="plan-activities-btn">
              <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>
              <label>Plan activities</label>
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="removeSelectedActivitiesFromPlanningMatrix()" size="large">
              <fa-icon [icon]="faMinus" [fixedWidth]="true"></fa-icon>
              <label>Remove from plan</label>
            </p-button>
          </div>
        </div>
      </div>
    } @else if (selectedActionsSelector === 'batch') {
      <div class="execution-status action-box">
        <label>Change execution status</label>
        <div class="action-controls">
          <div class="row">
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('notstarted')" size="small">
              <fa-icon [icon]="faTasks" [fixedWidth]="true"></fa-icon>
              Not started
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('inprogress')" size="small">
              <fa-icon [icon]="faRunning" [fixedWidth]="true"></fa-icon>
              In progress
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('finished')" size="small">
              <fa-icon [icon]="faFlagCheckered" [fixedWidth]="true"></fa-icon>
              Finished
            </p-button>
          </div>
          <div class="row">
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('blocked')" size="small">
              <fa-icon [icon]="faHandPaper" [fixedWidth]="true"></fa-icon>
              Blocked
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('skipped')" size="small">
              <fa-icon [icon]="faForward" [fixedWidth]="true"></fa-icon>
              Skipped
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setExecutionStatus('waitingforreview')" size="small">
              <fa-icon [icon]="faHourglass" [fixedWidth]="true"></fa-icon>
              Waiting for review
            </p-button>
          </div>
        </div>
      </div>
      <div class="evaluation-status action-box">
        <label>Change evaluation status</label>
        <div class="action-controls">
          <div class="row">
            <p-button [disabled]="!selectedActivitiesCount" (click)="setEvaluationStatus('undecided')" size="small">
              <fa-icon [icon]="faQuestionCircle" [fixedWidth]="true"></fa-icon>
              Undecided
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setEvaluationStatus('passed')" size="small">
              <fa-icon [icon]="faCheckCircle" [fixedWidth]="true"></fa-icon>
              Passed
            </p-button>
          </div>
          <div class="row">
            <p-button [disabled]="!selectedActivitiesCount" (click)="setEvaluationStatus('failed')" size="small">
              <fa-icon [icon]="faTimesCircle" [fixedWidth]="true"></fa-icon>
              Failed
            </p-button>
            <p-button [disabled]="!selectedActivitiesCount" (click)="setEvaluationStatus('notapplicable')" size="small">
              <fa-icon [icon]="faBan" [fixedWidth]="true"></fa-icon>
              <label>Not applicable</label>
            </p-button>
          </div>
        </div>
      </div>
      <div class="action-box automation-box">
        <p-button [disabled]="!selectedActivitiesCount" (click)="startAutomation()" size="large">
          <fa-icon [icon]="faRobot" [fixedWidth]="true"></fa-icon>
          Start Automation
        </p-button>
      </div>
    } @else if (selectedActionsSelector === 'select') {
      <div class="selection-status action-box">
        <label>Selection Status</label>
        <div class="action-controls">
          <div class="row">
            <p-button (click)="confirmSelection()" size="large">
              Confirm Selection
            </p-button>
          </div>
        </div>
      </div>
    }
  }
</div>

<div class="table-wrapper">
  <div class="legend">
    <div class="row">
      <fa-icon [icon]="faUserCheck"></fa-icon>
      <div class="title">= manual check required</div>
    </div>
    <div class="row">
      <fa-icon [icon]="faRobot"></fa-icon>
      <div class="title">= automated check possible</div>
    </div>
  </div>

  @if (loading) {
    <div class="spinner-container">
      <div class="spinner-centered semi-transparent">
        <p-progressSpinner></p-progressSpinner>
      </div>
    </div>
  }

  <table class="applicability-matrix" wmClickOutside [appClickOutsideExclude]="[actions, batchModeSelector]" [clickOutsideParent]="hostElement.nativeElement" (onClickOutside)="selectNone()">
    <tr>
      <th class="sticky x-header" (click)="selectAll()" data-testing-id="planning-table-corner-header"></th>
      @for (specId of sortedSpecIdsAccordingToDisplayId; track specId) {
        <th class="sticky y-header display-id" (click)="selectBySpec(specId, $event)">
          <div class="cell-header">{{ specs[specId]?.displayId }}</div>
        </th>
      }
    </tr>
    <tr>
      <th class="sticky x-header" (click)="selectAll()"></th>
      @for (specId of sortedSpecIdsAccordingToDisplayId; track specId) {
        <th class="sticky second y-header" (click)="selectBySpec(specId, $event)">
          <div class="cell-header">{{ specs[specId]?.title }}</div>
        </th>
      }
    </tr>
    @for (obj of testObjects; track obj.testObjectId) {
      <tr>
        <th class="sticky x-header" [pTooltip]="obj.target.name + (statesByTestObjectId[obj.testObjectId]?.name && statesByTestObjectId[obj.testObjectId]?.name !== obj.target.name ? '\n' + statesByTestObjectId[obj.testObjectId]?.name : '')" tooltipPosition="left" (click)="selectByTestObject(obj.testObjectId, $event)">
          <div class="cell-header">
            @if (obj.target.name) {
              <div class="objname">{{ obj.target.name }}</div>
            }
            @if (statesByTestObjectId[obj.testObjectId]?.name && statesByTestObjectId[obj.testObjectId]?.name !== obj.target.name) {
              <div class="statename">{{ statesByTestObjectId[obj.testObjectId].name }}</div>
            }
            @if (!obj.target.name && !statesByTestObjectId[obj.testObjectId]?.name) {
              <div class="objname">No name</div>
            }
          </div>
        </th>
        @for (specId of sortedSpecIdsAccordingToDisplayId; track specId) {
          <td class="cell {{activitiesBySpecAndTestObject[specId]?.[obj.testObjectId]?.evaluationStatus || 'undecided'}}" [ngClass]="{'on': matrix[obj.testObjectId]?.[specId], 'off': !matrix[obj.testObjectId]?.[specId], 'selected': !!selectedActivitiesBySpecAndTestObject[specId]?.[obj.testObjectId], 'unselectable': !matrix[obj.testObjectId]?.[specId] && (selectedActionsSelector === 'batch' || selectedActionsSelector === 'select')}" (click)="toggleCellSelection(obj.testObjectId, specId)" >
            @if (matrix[obj.testObjectId]?.[specId]; as task) {
              <div class="cell-details-btn"
                   pTooltip="Go to activity details"
                   tooltipPosition="top"
                   (click)="goToActivityDetails(specId, obj.testObjectId); $event.stopPropagation()">
                <fa-icon [icon]="faExternalLink"></fa-icon>
              </div>
              <div class="on cell-content">
                <div class="activity-info">
                  @if (obj.target.type !== "TagObservationTarget" && specs[specId].checkers.length > 0) {
                    <fa-icon [icon]="faRobot" pTooltip="Automated Check"></fa-icon>
                  } @else {
                    <fa-icon [icon]="faUserCheck" pTooltip="Manual Check"></fa-icon>
                  }

                  @if (activitiesBySpecAndTestObject[specId]?.[obj.testObjectId]; as act) {
                    <div class="execution-status">
                      @if (act.executionStatus === 'notstarted') {
                        <fa-icon class="notstarted" [icon]="faTasks" pTooltip="Not started"></fa-icon>
                      }
                      @if (act.executionStatus === 'inprogress') {
                        <fa-icon class="inprogress" [icon]="faRunning" pTooltip="In progress"></fa-icon>
                      }
                      @if (act.executionStatus === 'waitingforreview') {
                        <fa-icon class="waitingforreview" [icon]="faHourglass" pTooltip="Waiting for review"></fa-icon>
                      }
                      @if (act.executionStatus === 'finished') {
                        <fa-icon class="finished" [icon]="faFlagCheckered" pTooltip="Finished"></fa-icon>
                      }
                      @if (act.executionStatus === 'blocked') {
                        <fa-icon class="skipped" [icon]="faHandPaper" pTooltip="Blocked"></fa-icon>
                      }
                      @if (act.executionStatus === 'skipped') {
                        <fa-icon class="blocked" [icon]="faForward" pTooltip="Skipped"></fa-icon>
                      }
                    </div>
                  }
                  @if (!activitiesBySpecAndTestObject[specId]?.[obj.testObjectId]) {
                    <div class="execution-status">
                      <fa-icon class="notstarted" [icon]="faTasks" pTooltip="Not started"></fa-icon>
                    </div>
                  }
                </div>
                <div class="status">
                  @if (activitiesBySpecAndTestObject[specId]?.[obj.testObjectId]; as act) {
                    <div class="evaluation-status">
                      @if (act.evaluationStatus === 'undecided') {
                        <fa-icon class="undecided" [icon]="faQuestionCircle" pTooltip="Undecided"></fa-icon>
                      }
                      @if (act.evaluationStatus === 'passed') {
                        <fa-icon class="passed" [icon]="faCheckCircle" pTooltip="Passed"></fa-icon>
                      }
                      @if (act.evaluationStatus === 'failed') {
                        <fa-icon class="failed" [icon]="faTimesCircle" pTooltip="Failed"></fa-icon>
                      }
                      @if (act.evaluationStatus === 'notapplicable') {
                        <fa-icon class="notapplicable" [icon]="faBan" pTooltip="Not applicable"></fa-icon>
                      }

                    </div>
                  }
                  @if (!activitiesBySpecAndTestObject[specId]?.[obj.testObjectId]) {
                    <div class="evaluation-status">
                      <fa-icon class="undecided" [icon]="faQuestionCircle" pTooltip="Undecided"></fa-icon>
                    </div>
                  }
                  @if (!!findingStatsBySpecAndTestObject) {
                    <div class="number-of-findings" pTooltip="Number of findings">
                      <div class="number">{{ findingStatsBySpecAndTestObject[specId]?.[obj.testObjectId]?.total || 0 }}</div>
                    </div>
                  }
                </div>
              </div>
            } @else if (!matrix[obj.testObjectId]?.[specId] && selectedActionsSelector === 'batch') {
            } @else {
            }
          </td>
        }
      </tr>
    }
  </table>
</div>
